(function(){
  function init(section){
    if(!section || section.dataset.gyaCarouselReady==='true') return;
    const viewport=section.querySelector('[data-gya-carousel-viewport]');
    const track=section.querySelector('[data-gya-carousel-track]');
    if(!viewport || !track) return;
    const originals=Array.from(track.querySelectorAll('[data-gya-slide]'));
    if(originals.length<2) return;
    section.dataset.gyaCarouselReady='true';

    originals.forEach(slide=>{
      const clone=slide.cloneNode(true);
      clone.removeAttribute('data-gya-slide');
      clone.setAttribute('aria-hidden','true');
      clone.tabIndex=-1;
      track.appendChild(clone);
    });

    let index=0, timer=null, busy=false;
    let dragging=false, dragged=false, startX=0, startY=0, startOffset=0, pointerId=null;
    const gap=()=>parseFloat(getComputedStyle(track).gap)||0;
    const slideWidth=()=>track.children[0].getBoundingClientRect().width+gap();
    const progress=section.querySelector('[data-gya-carousel-progress]');
    const autoplay=section.dataset.autoplay==='true';
    const speed=(parseInt(section.dataset.speed,10)||4)*1000;

    function updateProgress(){
      if(progress){
        const visibleIndex=((index%originals.length)+originals.length)%originals.length;
        progress.style.transform=`scaleX(${(visibleIndex+1)/originals.length})`;
      }
    }
    function paint(animate=true, customOffset=null){
      track.style.transition=animate?'transform .62s cubic-bezier(.22,.61,.36,1)':'none';
      const offset=customOffset===null ? -index*slideWidth() : customOffset;
      track.style.transform=`translate3d(${offset}px,0,0)`;
      if(customOffset===null) updateProgress();
    }
    function normalizeAfterMove(){
      if(index>=originals.length){
        index=0; paint(false);
      } else if(index<0){
        index=originals.length-1; paint(false);
      }
    }
    function goTo(nextIndex){
      if(busy) return;
      busy=true; index=nextIndex; paint(true);
      setTimeout(()=>{normalizeAfterMove();busy=false;},660);
    }
    function next(){goTo(index+1)}
    function prev(){
      if(busy) return;
      if(index===0){index=originals.length;paint(false);track.getBoundingClientRect();}
      goTo(index-1);
    }
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    function start(){stop(); if(autoplay && !dragging && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer=setInterval(next,speed);}

    section.querySelector('[data-gya-carousel-next]')?.addEventListener('click',()=>{next();start();});
    section.querySelector('[data-gya-carousel-prev]')?.addEventListener('click',()=>{prev();start();});

    viewport.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse' && e.button!==0) return;
      stop(); dragging=true; dragged=false; pointerId=e.pointerId;
      startX=e.clientX; startY=e.clientY; startOffset=-index*slideWidth();
      viewport.classList.add('is-dragging');
      try{viewport.setPointerCapture(pointerId)}catch(_){ }
    });
    viewport.addEventListener('pointermove',e=>{
      if(!dragging || e.pointerId!==pointerId) return;
      const dx=e.clientX-startX, dy=e.clientY-startY;
      if(Math.abs(dx)>6 && Math.abs(dx)>Math.abs(dy)){dragged=true;e.preventDefault();paint(false,startOffset+dx);}
    });
    function endDrag(e){
      if(!dragging || (e && e.pointerId!==pointerId)) return;
      const dx=(e?e.clientX:startX)-startX;
      dragging=false; viewport.classList.remove('is-dragging');
      try{viewport.releasePointerCapture(pointerId)}catch(_){ }
      pointerId=null;
      const threshold=Math.min(90,slideWidth()*.18);
      if(dragged && Math.abs(dx)>threshold){
        if(dx<0) next(); else prev();
      } else paint(true);
      setTimeout(()=>{dragged=false;},80);
      start();
    }
    viewport.addEventListener('pointerup',endDrag);
    viewport.addEventListener('pointercancel',endDrag);
    viewport.addEventListener('lostpointercapture',()=>{if(dragging) endDrag();});
    viewport.addEventListener('click',e=>{if(dragged){e.preventDefault();e.stopPropagation();}},true);

    window.addEventListener('resize',()=>paint(false));
    paint(false); start();
  }
  function boot(root=document){root.querySelectorAll('[data-gya-carousel-section]').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>boot()); else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
